import { useMutation, useQuery } from '@tanstack/react-query';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { OrganizationsDTO } from './types/response';
import { MinutesDetailsApiService } from './services/api';
import { MinutesDetailsRequest, OrganizationFilter } from './types/request';

const minutesDetailsApiService = new MinutesDetailsApiService();

export const useGetOrganizations = (params: OrganizationFilter) => {
	const report = useQuery(['organization_ids'], () => minutesDetailsApiService.getOrganizations(params));

	return {
		...report,
		data: report?.data ?? ([] as OrganizationsDTO[])
	};
};

export const useGetMinutesDetails = () => {
	return useMutation((body: MinutesDetailsRequest) => minutesDetailsApiService.getMinutesDetails(body), {
		onError: () => {
			notification.error({
				message: `${I18n.get('Ops... something happened!')}`,
				description: `${I18n.get('Error in searching for user information')}`
			});
		}
	});
};
